import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SGloopMainCard from "./SGloopMainCard"; // adjust path

export default function SGloopMainList({ userData }) {
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 3;

  const groups = userData?.oneSGMain || [];
  const totalPages = Math.ceil(groups.length / cardsPerPage);

  const startIndex = (currentPage - 1) * cardsPerPage;
  const currentGroups = groups.slice(startIndex, startIndex + cardsPerPage);

  // Animation variants
  const cardVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
    exit: { opacity: 0, y: -10, transition: { duration: 0.3 } },
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
  };

  return (
    <div className="space-y-6">
      {groups.length > 0 ? (
        <>
          <AnimatePresence mode="wait">
            <motion.div key={currentPage} initial="hidden" animate="visible" exit="exit" variants={cardVariants} className="space-y-4">
              {currentGroups.map((main) => (
                <SGloopMainCard key={main.id} id={main.id} />
              ))}
            </motion.div>
          </AnimatePresence>

          {/* Pagination Controls */}
          <div className="flex items-center justify-center space-x-2">
            <button
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
              className="px-3 py-1 text-sm bg-gray-200 rounded-lg disabled:opacity-50 hover:bg-gray-300 transition"
            >
              Prev
            </button>

            <span className="text-sm text-gray-600">
              Page {currentPage} of {totalPages}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
              className="px-3 py-1 text-sm bg-gray-200 rounded-lg disabled:opacity-50 hover:bg-gray-300 transition"
            >
              Next
            </button>
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center justify-center py-12 text-center space-y-4 bg-gray-50 rounded-xl shadow-inner">
          <p className="text-gray-600 text-lg font-medium">
            You haven’t joined any groups yet
          </p>
          <button className="px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium rounded-lg shadow-md transition">
            Explore Groups
          </button>
        </div>
      )}
    </div>
  );
}
